<script>
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  resourceComputed,
  resourceListMethod,
  userListMethod,
  departmentListMethod,
  departmentComputed,
} from '@state/helpers'

export default {
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      title: '',
      description: '',
      date: '',
      assignedTo: [],
      document: [],
      resourceError: null,
      isResourceError: false,
      isLoading: false,
      show: false,
      platformId: 0,
      resourceSuccess: '',
      isSuccess: false,
      sizeError: false,
      typeError: false,
      videoTitle: [],
      videoUrl: [],
      videoUrl1: [],
      videoError: false,
      documentPrev: [],
      documentDeleted: [],
      classlist: [],
      collegeId: '',
      collegeClass: [],
      collegeClassPrev: [],
      departmentId: [],
      departmentlist: [],
      missingError: false,
    }
  },
  computed: {
    ...resourceComputed,
    ...authComputed,
    ...departmentComputed,
  },
  mounted() {
    if (this.role === 'college') {
      this.getDepartments()
    }
    this.collegeId = this.profileData.college_id
    if (this.role === 'hod') {
      // this.departmentId.push(this.profileData.department)
      this.getClasses()
    }
  },
  methods: {
    ...resourceListMethod,
    ...userListMethod,
    ...departmentListMethod,
    // save resource method
    saveResource() {
      this.isResourceError = false
      if (this.videoUrl1.length !== 0 && this.videoTitle.length === 0) {
        this.videoError = true
      } else if (this.videoUrl1.length === 0 && this.videoTitle.length !== 0) {
        this.videoError = true
      } else if (this.videoUrl1.length !== this.videoTitle.length) {
        this.videoError = true
      } else if (this.videoUrl1.length === 0 && this.videoTitle.length === 0) {
        this.videoUrl = []
      } else {
        this.videoError = false
        let i = 0
        for (i = 0; i < this.videoTitle.length; i++) {
          this.videoUrl.push({
            title: this.videoTitle[i],
            url: this.videoUrl1[i],
          })
        }
      }
      if (
        this.document.length === 0 &&
        this.videoUrl.length === 0 &&
        this.documentDeleted.length === this.documentPrev.length
      ) {
        this.missingError = true
      } else {
        this.missingError = false
      }
      if (
        !this.videoError &&
        !this.typeError &&
        !this.sizeError &&
        !this.missingError
      ) {
        let Data = {
          id: this.data._id,
          title: this.title,
          description: this.description,
          assigned_to: this.assignedTo,
          platform_id: this.currentUser.user.platform_id,
          document: [this.document, this.documentPrev, this.documentDeleted],
          collegeClass: [this.collegeClass, this.collegeClassPrev],
          department: this.departmentId,
          college_id: this.collegeId,
        }

        if (this.videoUrl.length !== 0 && this.videoTitle.length !== 0) {
          Data.video_url = this.videoUrl
        } else {
          Data.video_url = []
        }
        this.updateResourceData({ Data })
          .then((resource) => {
            this.isLoading = false
            this.resourceSuccess = 'Resource Updated Successfully'
            this.isSuccess = true
            window.location.reload()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.resourceError = getError.message
            this.isResourceError = true
          })
      }
    },
    handleFileUpload(event) {
      this.document = []
      this.sizeError = false
      this.typeError = false
      let files = event.target.files || event.dataTransfer.files
      let i = 0
      for (i = 0; i < files.length; i++) {
        if (files[i].type === 'application/pdf') {
          if (files[i].size <= 8000000) {
            let obj = {}
            obj['name'] = files[i].name
            const reader = new FileReader()
            reader.readAsDataURL(files[i])
            reader.onload = () => {
              obj['data'] = reader.result
            }
            this.document.push(obj)
          } else {
            this.sizeError = true
          }
        } else {
          this.typeError = true
        }
      }
    },

    getData() {
      this.assignedTo = []
      this.videoTitle = []
      this.videoUrl1 = []
      this.platformId = this.currentUser.user.platform_id
      this.title = this.data.title
      this.description = this.data.description
      let i = 0
      for (i = 0; i < this.data.assigned_to.length; i++) {
        this.assignedTo.push(this.data.assigned_to[i])
      }
      for (i = 0; i < this.data.department.length; i++) {
        this.departmentId.push(this.data.department[i])
      }
      this.getClasses()
      if (
        this.data.video_url !== undefined &&
        this.data.video_url.length !== 0
      ) {
        for (i = 0; i < this.data.video_url.length; i++) {
          this.videoTitle.push(this.data.video_url[i].title)
          this.videoUrl1.push(this.data.video_url[i].url)
        }
      }
      this.documentPrev = this.data.document
      for (i = 0; i < this.data.collegeClass.length; i++) {
        this.collegeClass.push(this.data.collegeClass[i])
        this.collegeClassPrev.push(this.data.collegeClass[i])
      }
    },

    resetModal() {
      this.departmentId = []
      this.assignedTo = []
      this.videoTitle = []
      this.videoUrl1 = []
      this.documentDeleted = []
      this.title = this.data.title
      this.description = this.data.description
      let i = 0
      for (i = 0; i < this.data.assigned_to.length; i++) {
        this.assignedTo.push(this.data.assigned_to[i])
      }
      this.document = []
      if (
        this.data.video_url !== undefined &&
        this.data.video_url.length !== 0
      ) {
        for (i = 0; i < this.data.video_url.length; i++) {
          this.videoTitle.push(this.data.video_url[i].title)
          this.videoUrl1.push(this.data.video_url[i].url)
        }
      }
      this.sizeError = false
      this.typeError = false
      this.videoError = false
      for (i = 0; i < this.data.collegeClass.length; i++) {
        this.collegeClass.push(this.data.collegeClass[i])
        this.collegeClassPrev.push(this.data.collegeClass[i])
      }
      this.isResourceError = false
    },

    getMinDate() {
      const now = new Date()
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
      const minDate = new Date(today)
      minDate.setDate(now.getDate() + 1)
      return minDate
    },

    tagValidator(tag) {
      /* eslint-disable */
      var res = tag.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      )
      if (res === null) {
      } else {
        return tag
      }
    },
    restrictChars(event) {
      if (event.charCode === 32 && !this.title.length) {
        event.preventDefault()
      } else {
        return true
      }
    },

    getDoc(item, key) {
      let output = confirm('Are you sure you want to delete file ' + item + '?')
      if (output === true) {
        this.documentDeleted.push(key)
      } else {
      }
    },
    getClasses() {
      this.fetchClassList()
        .then((classes) => {
          var listitems = []
          classes.forEach((element) => {
            var ele = {}
            let i = 0
            for (i = 0; i < this.departmentId.length; i++) {
              if (this.departmentId[i] === element.department) {
                ele.text = element.name
                ele.value = element._id
                ele.college = element.college_id
                listitems.push(ele)
              }
            }
          })
          this.classlist = listitems
          if (this.classlist.length > 1) {
            this.classlist.unshift({
              value: 'All',
              text: 'All',
            })
          }
        })
        .catch((_error) => {})
    },

    getDepartments() {
      this.departmentId = []
      const filter = {
        page: this.$route.query.page ? this.$route.query.page : 1,
        limit: 100,
        sort: 'sort_order',
        order: '-1',
      }
      this.fetchDepartmentList({ filter })
        .then((dept) => {
          var listitems = []
          dept.docs.forEach((element) => {
            if (element.college_id === this.collegeId) {
              var ele = {}
              ele.text = element.name
              ele.value = element._id
              listitems.push(ele)
            }
          })
          this.departmentlist = listitems
        })
        .catch((_error) => {})
    },
  },
}
</script>

<style>
.custom-file-input {
  z-index: 2 !important;
}
.delete-click {
  cursor: pointer;
  border: 1px solid black;
}
.notes {
  background: yellow;
}
</style>

<template>
  <b-modal
    id="resource-modal"
    title="Update "
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="resourceSuccess"
        ></b-alert>
        <p v-if="videoError" style="color: red"
          >Please Add Title/URL for Video</p
        >
        <p v-if="missingError" style="color: red"
          >Please Add Document or Video URL</p
        >
        <b-form @submit.prevent="saveResource">
          <b-form-group label="Resource Title" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="title"
              type="text"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Resource Description" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="description"
              type="text"
            ></b-form-input>
          </b-form-group>
          <b v-if="documentPrev.length >= 1">Uploaded Document(s):</b><br />
          <b class="notes"
            >Note: File will not be deleted till the save button is clicked.</b
          >
          <p
            v-for="(item, k) in documentPrev"
            v-if="!documentDeleted.includes(k)"
            :key="k"
          >
            {{ item }}
            <a class="delete-click" @click="getDoc(item, k)">&#10005;</a>
          </p>
          <b-form-group
            label="Update PDF File(Max Size:8 MB)"
            label-for="document"
          >
            <b-form-file
              id="document"
              ref="file"
              type="file"
              placeholder="Click here to add file"
              accept=".pdf"
              multiple
              @change="handleFileUpload"
            ></b-form-file>
          </b-form-group>
          <p v-if="sizeError" style="color: red"
            >Please upload file less than 8 MB</p
          >
          <p v-if="typeError" style="color: red"
            >Please upload only pdf files</p
          >
          <b-form-group
            label="Video URL(Multiple URLs can be added,add embedded links)"
            label-for="videoUrl1"
          >
            <b-form-tags
              v-model="videoTitle"
              tag-pills
              class="mb-2"
              separator=","
              placeholder="Add Video Title separated by comma"
            ></b-form-tags>
            <b-form-tags
              v-model="videoUrl1"
              tag-pills
              class="mb-2"
              separator=","
              placeholder="Add associated Video URL in sequence separated by comma"
              :tag-validator="tagValidator"
              invalid-tag-text="Invalid URL"
            ></b-form-tags>
          </b-form-group>
          <b-form-group
            v-if="role !== 'hod' && role !== 'teacher'"
            label="Department"
            label-for="input-1"
          >
            <b-form-select
              v-model="departmentId"
              :options="departmentlist"
              multiple
              @change="getClasses"
            ></b-form-select>
          </b-form-group>
          <b-form-group
            v-if="role !== 'teacher'"
            label="Class"
            label-for="input-1"
          >
            <b-form-select
              v-model="collegeClass"
              :options="classlist"
              multiple
            ></b-form-select>
          </b-form-group>
          <b-alert
            v-model="isResourceError"
            variant="danger"
            v-html="resourceError"
          ></b-alert>
          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Save</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
